import { DollarOutlined } from '@ant-design/icons-vue';

// 用 () => import() 避免 router 注入時同步載入，造成 "Cannot access before initialization"
export const financeRoutes = [
    {
        path: 'finance',
        name: 'Finance',
        meta: {
            title: '資料設置',
            icon: DollarOutlined
        },
        children: [
            {
                path: 'types',
                component: () => import('@/views/finance/TypeList.vue'),
                name: 'TypeList',
                meta: { title: '類型管理' }
            },
            {
                path: 'options',
                component: () => import('@/views/finance/OptionList.vue'),
                name: 'OptionList',
                meta: { title: '選項管理' }
            }
        ]
    }
];
